import mrIN from '../../date-picker/locale/mr_IN';
export default mrIN;
